import React, { useState, useEffect, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import MuiButton from "@material-ui/core/Button";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import CustomTabs from "components/CustomTabs/CustomTabs.js";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import ReactTable from "components/ReactTable/ReactTable";
import {
  MessageOutlined,
  RemoveRedEye,
  Close,
} from "@material-ui/icons";

const currentUser = JSON.parse(localStorage.getItem("user") || "{}");

const options = [
  { value: "admin", label: "Organization admin" },
  { value: "teacher", label: "Teacher/Tutor" },
  { value: "parent", label: "Parent/Guardian" },
  { value: "student", label: "Student" },
];

const optionsTeacher = [
  { value: "teacher", label: "Teacher/Tutor" },
  { value: "parent", label: "Parent/Guardian" },
  { value: "student", label: "Student" },
];

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "12px",
    textTransform: "uppercase",
    marginTop: "0",
    marginBottom: "0",
    marginLeft: "20px",
    fontWeight: "300",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "5px",
    minHeight: "auto",
    fontSize: "16px",
    fontWeight: "300",
    fontFamily: "'Poppins', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    marginLeft: "20px",
    textDecoration: "none",
    textTransform: "uppercase",
    paddingTop: "5px",
  },
  searchWrapper: {
    marginTop: "10px",
  },
  dialogTitleRoot: {
    padding: "0",
  },
  dialogHeader: {
    backgroundColor: "#6B9D94",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 20px",
  },
  dialogHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  logo: {
    width: "70px",
    height: "30px",
    objectFit: "contain",
  },
  dialogContent: {
    padding: "24px !important",
  },
  reportDialogContent: {
    padding: "24px !important",
  },
  dialogActions: {
    padding: "16px 24px 24px 24px",
    display: "flex",
    justifyContent: "flex-start",
    gap: "10px",
    flexWrap: "wrap",
  },
  metricsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    gap: "16px",
    marginTop: "20px",
    marginBottom: "20px",
  },
  metricCard: {
    backgroundColor: "#353333",
    borderRadius: "16px",
    padding: "16px",
    textAlign: "center",
  },
  metricLabel: {
    fontSize: "14px",
    color: "#D1D5DB",
    fontWeight: 600,
    marginBottom: "8px",
  },
  metricValue: {
    fontSize: "24px",
    fontWeight: 800,
    color: "#F3F4F6",
  },
  fluencyValue: {
    fontSize: "24px",
    fontWeight: 800,
    color: "#EF4444",
  },
};

const useStyles = makeStyles(styles);

export default function UserProfile() {
  const classes = useStyles();

  const [newUserOrganization, setNewUserOrganization] = useState("");
  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserRole, setNewUserRole] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [postalCode, setPostalCode] = useState("");

  const [allStudents, setAllStudents] = useState([]);
  const [allIndependentReaders, setAllIndependentReaders] = useState([]);
  const [allAdmin, setAllAdmin] = useState([]);
  const [allParents, setAllParents] = useState([]);
  const [allTeachers, setAllTeachers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [allOrganizations, setAllOrganizations] = useState([]);

  const [openMessage, setOpenMessage] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState({
    first_name: "",
    last_name: "",
    email: "",
    group: "",
  });
  const [messageText, setMessageText] = useState("");

  const [openReport, setOpenReport] = useState(false);
  const [selectedStudentForReport, setSelectedStudentForReport] = useState({
    first_name: "",
    last_name: "",
    email: "",
    product_code: "",
    metrics: {
      quizPercent: 85,
      minutesPerDay: 32,
      wpm: 145,
      comprehension: 78,
      fluency: "Advanced"
    }
  });

  const option = allOrganizations;

  const handleOpenMessage = (student) => {
    console.log("Opening message modal for:", student);

    setSelectedStudent({
      first_name: student.student_first_name || "",
      last_name: student.student_last_name || "",
      email: student.student_email || "",
      group: student.product_code || "",
    });

    setMessageText("");
    setOpenMessage(true);
  };

  const handleViewReport = (student) => {
    console.log("View report for:", student);
    
    // Dummy metrics data for demonstration
    const dummyMetrics = {
      quizPercent: Math.floor(Math.random() * 30) + 70, // Random between 70-100
      minutesPerDay: Math.floor(Math.random() * 40) + 15, // Random between 15-55
      wpm: Math.floor(Math.random() * 150) + 80, // Random between 80-230
      comprehension: Math.floor(Math.random() * 30) + 65, // Random between 65-95
      fluency: ["1", "2", "10", "5"][Math.floor(Math.random() * 4)]
    };
    
    setSelectedStudentForReport({
      first_name: student.student_first_name || "",
      last_name: student.student_last_name || "",
      email: student.student_email || "",
      product_code: student.product_code || "",
      metrics: dummyMetrics
    });
    
    setOpenReport(true);
  };

  const onCloseMessage = () => {
    setOpenMessage(false);
    setMessageText("");
    setSelectedStudent({
      first_name: "",
      last_name: "",
      email: "",
      group: "",
    });
  };

  const onCloseReport = () => {
    setOpenReport(false);
    setSelectedStudentForReport({
      first_name: "",
      last_name: "",
      email: "",
      product_code: "",
      metrics: {
        quizPercent: 0,
        minutesPerDay: 0,
        wpm: 0,
        comprehension: 0,
        fluency: ""
      }
    });
  };

  const handleSendMessage = async (sendType) => {
    if (!messageText.trim()) {
      toast.error("Please enter a message first.", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    try {
      console.log("Sending message type:", sendType);
      console.log("Selected student:", selectedStudent);
      console.log("Message text:", messageText);

      // Here you can connect your actual API endpoint
      // Example:
      // const headers = {
      //   "Content-Type": "application/json",
      //   Authorization: "Bearer " + currentUser.accessToken,
      // };
      //
      // await axios.post(
      //   process.env.REACT_APP_API_URL + "messages/send",
      //   {
      //     sendType,
      //     email: selectedStudent.email,
      //     group: selectedStudent.group,
      //     message: messageText,
      //   },
      //   { headers }
      // );

      toast.success(
        sendType === "single"
          ? `Message sent to ${selectedStudent.first_name} ${selectedStudent.last_name}`
          : sendType === "group"
          ? `Message sent to group ${selectedStudent.group || ""}`
          : "Message sent to all groups",
        {
          position: toast.POSITION.TOP_CENTER,
        }
      );

      onCloseMessage();
    } catch (error) {
      console.error("Send message error:", error);
      toast.error("Failed to send message", {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "Organization",
        accessor: "organization",
      },
      {
        Header: "Role",
        accessor: "role",
      },
    ],
    []
  );

  const columns2 = useMemo(
    () => [
      {
        Header: "First Name",
        accessor: "student_first_name",
      },
      {
        Header: "Last Name",
        accessor: "student_last_name",
      },
      {
        Header: "Email",
        accessor: "student_email",
      },
      {
        Header: "Product",
        accessor: "product_code",
      },
      {
        Header: "Current Title",
        accessor: "title",
      },
      {
        Header: "Author",
        accessor: "author",
      },
      {
        Header: "Start",
        accessor: "start_date",
      },
      // {
      //   Header: "End",
      //   accessor: "end_date",
      // },
      {
        Header: "MSG",
        accessor: "message",
        Cell: ({ row }) => (
          <MessageOutlined
            style={{ color: "grey", cursor: "pointer" }}
            onClick={() => handleOpenMessage(row.original)}
          />
        ),
      },
      {
        Header: "MRR",
        accessor: "mrr",
        Cell: ({ row }) => (
          <RemoveRedEye
            style={{ color: "grey", cursor: "pointer" }}
            onClick={() => handleViewReport(row.original)}
          />
        ),
      },
    ],
    []
  );

  const handleAddNewUser = (e) => {
    e.preventDefault();

    const newUser = {
      organization:
        currentUser.role === "organization"
          ? currentUser.organization
          : currentUser.role === "admin"
          ? currentUser.organization
          : currentUser.role === "teacher"
          ? currentUser.organization
          : newUserOrganization?.value,
      firstName: firstName,
      lastName: lastName,
      email: newUserEmail,
      role: newUserRole?.value,
      city: city,
      country: country,
      postalCode: postalCode,
    };

    if (new Date() > new Date(currentUser.expiresInTime)) {
      toast.error("Unautorized User. Please log In", {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem("user");
      window.location.href = "/";
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + currentUser.accessToken,
    };

    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(newUserEmail) ===
      false
    ) {
      toast.error("Email field is invalid", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!newUserRole?.value) {
      toast.error("New user role field is invalid", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!firstName) {
      toast.error("First name field is invalid", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!lastName) {
      toast.error("Last name field is invalid", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (
      !newUserOrganization &&
      currentUser.role !== "organization" &&
      currentUser.role !== "admin" &&
      currentUser.role !== "teacher"
    ) {
      toast.error("New user organization field is invalid", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API_URL + "users/new",
        {
          newUser,
        },
        { headers }
      )
      .then((response) => {
        if (response.data.code === 200) {
          toast.success(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
          });
          window.location.reload(false);
        } else {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        toast.error("Failed to add user");
      });
  };

  const getAllUsers = () => {
    if (new Date() > new Date(currentUser.expiresInTime)) {
      toast.error("Unautorized User. Please log In", {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem("user");
      window.location.href = "/";
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + currentUser.accessToken,
    };

    fetch(process.env.REACT_APP_API_URL + `users/${currentUser.organization}`, {
      headers,
    })
      .then((res) => res.json())
      .then((data1) => {
        const arr = [];
        const admin = [];
        const student = [];
        const parent = [];
        const teacher = [];
        const allOrga = [];
        const data = data1.data || [];

        if (
          currentUser.role === "organization" ||
          currentUser.role === "admin" ||
          currentUser.role === "teacher"
        ) {
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].role === "student" &&
              data[i].organization === currentUser.organization
            ) {
              student.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (
              data[i].role === "teacher" &&
              data[i].organization === currentUser.organization
            ) {
              teacher.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (
              data[i].role === "parent" &&
              data[i].organization === currentUser.organization
            ) {
              parent.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (
              (data[i].role === "admin" || data[i].role === "organization") &&
              data[i].organization === currentUser.organization
            ) {
              admin.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            }
          }
        } else if (
          currentUser.role === "student" ||
          currentUser.role === "parent"
        ) {
          for (let i = 0; i < data.length; i++) {
            if (
              data[i].role === "student" &&
              data[i].organization === currentUser.organization
            ) {
              student.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (
              data[i].role === "teacher" &&
              data[i].organization === currentUser.organization
            ) {
              teacher.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              arr.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            }
          }
        } else {
          for (let i = 0; i < data.length; i++) {
            if (data[i].role === "student") {
              student.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (data[i].role === "teacher") {
              teacher.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (data[i].role === "parent") {
              parent.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
            } else if (
              data[i].role === "admin" ||
              data[i].role === "organization"
            ) {
              admin.push({
                email: data[i].email,
                organization: data[i].organization,
                role: data[i].role,
              });
              allOrga.push({
                value: data[i].organization,
                label: data[i].organization,
              });
            }

            arr.push({
              email: data[i].email,
              organization: data[i].organization,
              role: data[i].role,
            });
          }
        }

        setAllUsers(arr);
        setAllStudents(student);
        setAllTeachers(teacher);
        setAllAdmin(admin);
        setAllParents(parent);
        setAllOrganizations(allOrga);
      });
  };

  const getIndependentReaders = () => {
    if (new Date() > new Date(currentUser.expiresInTime)) {
      toast.error("Unauthorized User. Please log In", {
        position: toast.POSITION.TOP_CENTER,
      });
      localStorage.removeItem("user");
      window.location.href = "/";
      return;
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + currentUser.accessToken,
    };

    fetch(process.env.REACT_APP_API_URL + `eop/users/latest-bookmarks`, {
      headers,
    })
      .then((res) => res.json())
      .then((data1) => {
        const arr = [];
        const data = data1.data || [];

        for (let i = 0; i < data.length; i++) {
          arr.push({
            student_email: data[i].student_email,
            student_first_name: data[i].student_first_name,
            student_last_name: data[i].student_last_name,
            product_code: data[i].product_code,
            title: data[i].title || "N/A",
            author: data[i].author || "N/A",
            start_date: data[i].created_at
  ? new Intl.DateTimeFormat('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' })
      .format(new Date(data[i].created_at))
  : "N/A",
            end_date: data[i].end_date || "N/A",
          });
        }

        setAllIndependentReaders(arr);
      })
      .catch((error) => {
        console.error("Error fetching independent readers:", error);
      });
  };

  useEffect(() => {
    getAllUsers();
    getIndependentReaders();
  }, []);

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title=""
            headerColor="primary"
            tabs={[
              {
                tabName: "Add User",
                tabContent: (
                  <Card>
                    {currentUser.role === "student" || currentUser.role === "parent" ? null : (
                      <div>
                        <CardHeader color="primary">
                          <h4 className={classes.cardTitleWhite}>User Profile</h4>
                          <p className={classes.cardCategoryWhite}>
                            Complete user profile
                          </p>
                        </CardHeader>

                        <CardBody>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={6}>
                              <CustomInput
                                labelText="Email address"
                                id="email-address"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: newUserEmail,
                                  onChange: (e) => setNewUserEmail(e.target.value),
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={1}></GridItem>

                            <GridItem xs={12} sm={12} md={5}>
                              <br />
                              {currentUser.role !== "teacher" ? (
                                <Select
                                  value={newUserRole}
                                  onChange={setNewUserRole}
                                  options={options}
                                />
                              ) : (
                                <Select
                                  value={newUserRole}
                                  onChange={setNewUserRole}
                                  options={optionsTeacher}
                                />
                              )}
                            </GridItem>
                          </GridContainer>

                          <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                              <br />
                              {currentUser.role === "organization" ||
                              currentUser.role === "admin" ||
                              currentUser.role === "teacher" ? (
                                <strong>
                                  Organization: {currentUser.organization}
                                </strong>
                              ) : (
                                <Select
                                  value={newUserOrganization}
                                  onChange={setNewUserOrganization}
                                  options={option}
                                />
                              )}
                            </GridItem>

                            <GridItem xs={12} sm={12} md={1}></GridItem>

                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="First Name"
                                id="first-name"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: firstName,
                                  onChange: (e) => setFirstName(e.target.value),
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={1}></GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Last Name"
                                id="last-name"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: lastName,
                                  onChange: (e) => setLastName(e.target.value),
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <br />

                          <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="City"
                                id="city"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: city,
                                  onChange: (e) => setCity(e.target.value),
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={1}></GridItem>

                            <GridItem xs={12} sm={12} md={3}>
                              <CustomInput
                                labelText="Country"
                                id="country"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: country,
                                  onChange: (e) => setCountry(e.target.value),
                                }}
                              />
                            </GridItem>

                            <GridItem xs={12} sm={12} md={1}></GridItem>

                            <GridItem xs={12} sm={12} md={4}>
                              <CustomInput
                                labelText="Postal Code"
                                id="postal-code"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  value: postalCode,
                                  onChange: (e) => setPostalCode(e.target.value),
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <br />
                        </CardBody>

                        <CardFooter>
                          <Button color="secondary" onClick={handleAddNewUser}>
                            Add User
                          </Button>
                        </CardFooter>
                      </div>
                    )}
                  </Card>
                ),
              },
              {
                tabName: "All Users",
                tabContent: (
                  <div className={classes.searchWrapper}>
                    <ReactTable columns={columns} data={allUsers} />
                  </div>
                ),
              },
              {
                tabName: "All Admins",
                tabContent: (
                  <div>
                    {currentUser.role === "student" || currentUser.role === "parent" ? null : (
                      <div className={classes.searchWrapper}>
                        <ReactTable columns={columns} data={allAdmin} />
                      </div>
                    )}
                  </div>
                ),
              },
              {
                tabName: "All Teachers",
                tabContent: (
                  <div className={classes.searchWrapper}>
                    <ReactTable columns={columns} data={allTeachers} />
                  </div>
                ),
              },
              {
                tabName: "All Parents",
                tabContent: (
                  <div>
                    {currentUser.role === "student" || currentUser.role === "parent" ? null : (
                      <div className={classes.searchWrapper}>
                        <ReactTable columns={columns} data={allParents} />
                      </div>
                    )}
                  </div>
                ),
              },
              {
                tabName: "All Students",
                tabContent: (
                  <div className={classes.searchWrapper}>
                    <ReactTable columns={columns} data={allStudents} />
                  </div>
                ),
              },
              {
                tabName: "Independent Readers",
                tabContent: (
                  <div className={classes.searchWrapper}>
                    <ReactTable columns={columns2} data={allIndependentReaders} />
                  </div>
                ),
              },
            ]}
          />
        </GridItem>
      </GridContainer>

      {/* Message Dialog */}
      <Dialog
        open={openMessage}
        onClose={onCloseMessage}
        fullWidth
        maxWidth="md"
        aria-labelledby="send-message-dialog-title"
      >
        <DialogTitle
          id="send-message-dialog-title"
          className={classes.dialogTitleRoot}
        >
          <div className={classes.dialogHeader}>
            <div className={classes.dialogHeaderLeft}>
              <Typography variant="h6" style={{ color: "#fff", fontWeight: 600 }}>
                Send Message
              </Typography>
            </div>

            <IconButton onClick={onCloseMessage} style={{ color: "#fff" }}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent className={classes.dialogContent}>
          <Typography
            variant="subtitle1"
            style={{ fontWeight: 700, marginBottom: 16 }}
          >
            SEND MESSAGE TO: {selectedStudent.first_name}{" "}
            {selectedStudent.last_name}
          </Typography>

          <TextField
            label="Compose Message"
            placeholder="Type your message here..."
            multiline
            rows={6}
            variant="outlined"
            fullWidth
            value={messageText}
            onChange={(e) => setMessageText(e.target.value)}
          />
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <MuiButton
            variant="contained"
            style={{ backgroundColor: "#F2B500", color: "#000" }}
            onClick={() => handleSendMessage("single")}
          >
            Send to This Student
          </MuiButton>

          <MuiButton
            variant="contained"
            style={{ backgroundColor: "#F2B500", color: "#000" }}
            onClick={() => handleSendMessage("group")}
          >
            Send to All Students
          </MuiButton>
        </DialogActions>
      </Dialog>

      {/* Reading Report Dialog */}
      <Dialog
        open={openReport}
        onClose={onCloseReport}
        fullWidth
        maxWidth="md"
        aria-labelledby="reading-report-dialog-title"
      >
        <DialogTitle
          id="reading-report-dialog-title"
          className={classes.dialogTitleRoot}
        >
          <div className={classes.dialogHeader}>
            <div className={classes.dialogHeaderLeft}>
              <Typography variant="h6" style={{ color: "#fff", fontWeight: 600 }}>
                Reading Report
              </Typography>
            </div>
            <IconButton onClick={onCloseReport} style={{ color: "#fff" }}>
              <Close />
            </IconButton>
          </div>
        </DialogTitle>

        <DialogContent className={classes.reportDialogContent}>
          {/* Student Info */}
          <Typography
            variant="subtitle1"
            style={{ fontWeight: 700, marginBottom: 8 }}
          >
            {selectedStudentForReport.first_name} {selectedStudentForReport.last_name}
          </Typography>
          
          <Typography
            variant="body2"
            style={{ color: "#666", marginBottom: 24 }}
          >
            {selectedStudentForReport.email} | Product: {selectedStudentForReport.product_code}
          </Typography>

          {/* Metrics Grid */}
          <div className={classes.metricsGrid}>
            {/* Quiz Completion */}
            <div className={classes.metricCard}>
              <div className={classes.metricLabel}>Completion</div>
              <div className={classes.metricValue}>
                {selectedStudentForReport.metrics.quizPercent}%
              </div>
            </div>

            {/* Minutes Per Day */}
            <div className={classes.metricCard}>
              <div className={classes.metricLabel}>Min Day</div>
              <div className={classes.metricValue}>
                {selectedStudentForReport.metrics.minutesPerDay}
              </div>
            </div>

            {/* Words Per Minute */}
            <div className={classes.metricCard}>
              <div className={classes.metricLabel}>Words Min</div>
              <div className={classes.metricValue}>
                {selectedStudentForReport.metrics.wpm}
              </div>
            </div>

            {/* Comprehension */}
            <div className={classes.metricCard}>
              <div className={classes.metricLabel}>Comprehension</div>
              <div className={classes.metricValue}>
                {selectedStudentForReport.metrics.comprehension}%
              </div>
            </div>

            {/* Fluency */}
            <div className={classes.metricCard}>
              <div className={classes.metricLabel}>Fluency</div>
              <div className={classes.fluencyValue}>
                {selectedStudentForReport.metrics.fluency}
              </div>
            </div>
          </div>
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <MuiButton
            variant="contained"
            style={{ backgroundColor: "#6B9D94", color: "#fff" }}
            onClick={onCloseReport}
          >
            Close
          </MuiButton>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </div>
  );
}